import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { messageActions } from "_actions";
import { validate as validateUUID } from "uuid";
import _ from "lodash";
import LoadingSpinner from "../../Channels/Utilities/LoadingSpinner";
import { getCurrentUser, isObjectEmpty } from "_helpers";
import { requestOrigin } from "_constants";
import InboxConversation from "./Utilities/InboxConversation";
import { platformConstants } from "_constants";

export default function InboxDetailsV3() {
  const dispatch = useDispatch();
  const params = useParams();
  const currentUser = getCurrentUser();
  const { id } = params;

  const _conversation = useSelector((state) => state.conversation.conversation);
  const conversationLoading = useSelector(
    (state) => state.conversation.loading,
  );
  const companyReplied = useSelector((state) => state.users.companyReplied);
  const markAsDone = useSelector((state) => state.users.markAsDone);
  const conversation =
    _conversation.constructor === Array
      ? _.get(_conversation, "0")
      : _conversation;

  const isTeamsId = validateUUID(id);
  const hasConversation = !isObjectEmpty(conversation);

  useEffect(() => {
    const platform = isTeamsId
      ? platformConstants.TEAMS
      : platformConstants.TRENDS;

    dispatch(messageActions.getFullEmailConversation(id, platform));
    if (isTeamsId) {
      dispatch(
        messageActions.getConversation(id, {}, requestOrigin.INBOX_DETAILS_V2),
      );
    } else {
      dispatch(
        messageActions.getConversationFromTrends(
          id,
          {},
          null,
          requestOrigin.INBOX_DETAILS_V2,
        ),
      );
    }
  }, []);

  return (
    <Box sx={styles.root}>
      <Box sx={styles.container}>
        <Box width="fit-content">
          <RouterLink to={"/inbox-v2"} className="tms-no-underline">
            <Box sx={styles.backLink}>
              <Box>
                <ArrowBackIosNewIcon sx={styles.arrowBack} />
              </Box>
              <Box mt={"1px"}> Back to inbox</Box>
            </Box>
          </RouterLink>
        </Box>

        <Box sx={styles.bodyWrapper}>
          {conversationLoading && !hasConversation ? (
            <Box
              sx={{
                height: "400px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LoadingSpinner />
            </Box>
          ) : (
            <InboxConversation
              conversation={conversation}
              currentUser={currentUser}
              messageId={id}
              companyReplied={companyReplied}
              markAsDone={markAsDone}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}

const styles = {
  root: {
    pt: 12,
    minHeight: "100vh",
    backgroundColor: "#EDEDE4",
  },
  container: {
    px: { xs: 2, sm: 4, md: 6 },
    width: "100%",
    maxWidth: "1440px",
    position: "relative",
    mx: "auto",
  },
  bodyWrapper: {
    position: "relative",
    mt: 2,
  },
  arrowBack: {
    color: "#003300",
    marginRight: "8px",
    borderRadius: "0px",
    fontSize: "14px",
    position: "absolute",
    left: "0",
    top: "3px",
  },
  backLink: {
    color: "#302E2A",
    position: "relative",
    fontFamily: "FustatBold",
    fontSize: "14px",
    display: "flex",
    alignItems: "flex-end",
    gap: "20px",
  },
};
